import script from "./RoutingAddressCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoutingAddressCard.vue?vue&type=script&setup=true&lang=ts"

import "./RoutingAddressCard.vue?vue&type=style&index=0&id=26d6821e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d6821e"]])

export default __exports__